import { render, staticRenderFns } from "./newPW.vue?vue&type=template&id=f3d820a2&scoped=true&"
import script from "./newPW.vue?vue&type=script&lang=js&"
export * from "./newPW.vue?vue&type=script&lang=js&"
import style0 from "./newPW.vue?vue&type=style&index=0&id=f3d820a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d820a2",
  null
  
)

export default component.exports